import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

ReactModal.setAppElement("#root");

function CreaEquipoUrgencias({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [servicio, setServicio] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoUrgencias",
      data: {
        nombre,
        servicio,
        cargo,
        lider,
        SolicitudId: idSolicitud,
      },
    })
      .then(() => {
        onCreated(); // ⬅️ recarga lista
        setIsOpen(false);
        setNombre("");
        setServicio("");
        setCargo("");
        setLider("");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear registro");
      });
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nuevo
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Crear Equipo"
      >
        <br></br> <br></br>
        <h5>Crear EQUIPO PRIMARIO DE MEJORAMIENTO DE URGENCIAS</h5>
        <form onSubmit={postData}>
          <input
            className="form-control mb-2"
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Servicio"
            value={servicio}
            onChange={(e) => setServicio(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Cargo"
            value={cargo}
            onChange={(e) => setCargo(e.target.value)}
            required
          />

          <select
            className="form-control mb-3"
            value={lider}
            onChange={(e) => setLider(e.target.value)}
            required
          >
            <option value="">¿Es líder?</option>
            <option value="Si">Sí</option>
            <option value="No">No</option>
          </select>

          <button className="btn btn-primary mr-2" type="submit">
            Guardar
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </button>
        </form>
      </ReactModal>
    </>
  );
}

export default CreaEquipoUrgencias;
